export default __webpack_public_path__ + "static/media/Arm-straps of the Blood God.a33e4887.jpg";